import { LineItemTemplate, LineItemTemplateCode } from "types";

export const getLineItemTemplateByCode = (
    lineItemTemplates: LineItemTemplate[],
    code: string | LineItemTemplateCode,
) => {
    return lineItemTemplates.find((template) => {
        return template.code === code;
    });
};
